import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

  private readonly statisticsURL: string;

  constructor(private http: HttpClient) {
    this.statisticsURL = "/catalog/statistics";
  }

  public getDevicesPerTenant(from: number) {
    const params = new HttpParams().append('from', from.toString());
    let url = `${this.statisticsURL}/devices_per_tenant`;
    return this.http.get<any>(url, {params: params});
  }

  public getSignalsPerTenant(from: number) {
    const params = new HttpParams().append('from', from.toString());
    let url = `${this.statisticsURL}/signals_per_tenant`;
    return this.http.get<any>(url, {params: params});
  }

}
